/**
 * Tooltip/typed.ts
 * desc: typed view of the still-JS Tooltip for components written in TypeScript
 * note: delete when Tooltip converts — the cast masks its real signature
 */
import type { ComponentType, MouseEvent, ReactNode } from 'react';
import TooltipUntyped from './index';

export interface TooltipProps {
    align?: 'start' | 'center' | 'end';
    alignOffset?: number;
    arrow?: boolean;
    asChild?: boolean;
    children: ReactNode;
    contentAriaLabel?: string;
    contentClassName?: string;
    onOpenChange?: (open: boolean) => void;
    onTriggerClick?: (event: MouseEvent<HTMLElement>) => void;
    open?: boolean;
    side?: 'top' | 'right' | 'bottom' | 'left';
    sideOffset?: number;
    // null renders the children without a tooltip
    text: string | null;
}

const Tooltip = TooltipUntyped as unknown as ComponentType<TooltipProps>;

export default Tooltip;
